// extracted by css-extract-rspack-plugin
export default {"subfolder":"r4xbfv"};